import { Outlet } from 'react-router-dom'
import { ProjectProvider, useProject } from '../contexts/ProjectContext'
import LoadingState from '../shared/components/LoadingState'
import ErrorState from '../shared/components/ErrorState'

function ProjectContent() {
  const { loading, error } = useProject()

  if (loading) return <LoadingState />
  if (error) return <ErrorState messageId="dockerProjects.error" />

  return <Outlet />
}

function ProjectLayout() {
  return (
    <ProjectProvider>
      <ProjectContent />
    </ProjectProvider>
  )
}

export default ProjectLayout
